module.exports = "<div>\r\n    <p>\r\n      Silmek sitediğinize emin misiniz?\r\n    </p>\r\n  \r\n    <button mat-raised-button color=\"warn\" style=\"float: right\" (click)=\"delete()\">Sil</button>\r\n  </div>\r\n "


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadviceadminSkeleton/src/app/main/content/corporate-leads/dialog/dialog.component.html
// module id = ../../../../../src/app/main/content/corporate-leads/dialog/dialog.component.html
// module chunks = main